<template>
  <div class="container-padding">
    <div id="desktop">
      <b-button-group>
        <b-button
          class="btn"
          @click="setLangView('br')"
          :variant="langSelected === 'br' ? 'primary' : ''"
          ><country-flag country="br" size="normal"
        /></b-button>
        <b-button
          class="btn"
          @click="setLangView('us')"
          :variant="langSelected === 'us' ? 'primary' : ''"
          ><country-flag country="us" size="normal"
        /></b-button>
        <b-button
          class="btn"
          @click="setLangView('es')"
          :variant="langSelected === 'es' ? 'primary' : ''"
          ><country-flag country="es" size="normal"
        /></b-button>
      </b-button-group>
    </div>
    <div class="main">
      <div class="align-items">
        <div
          style="
            display: flex;
            justify-content: space-between;
            align-items: center;
          "
        >
          <img class="logo-header" src="../../../assets/logo-indecx.png" />
          <b-button-group id="mobile">
            <b-button
              class="btn"
              @click="setLangView('br')"
              :variant="langSelected === 'br' ? 'primary' : ''"
              ><country-flag country="br" size="normal"
            /></b-button>
            <b-button
              class="btn"
              @click="setLangView('us')"
              :variant="langSelected === 'us' ? 'primary' : ''"
              ><country-flag country="us" size="normal"
            /></b-button>
            <b-button
              class="btn"
              @click="setLangView('es')"
              :variant="langSelected === 'es' ? 'primary' : ''"
              ><country-flag country="es" size="normal"
            /></b-button>
          </b-button-group>
        </div>
        <div class="content-text">
          <div v-if="langSelected === 'br'">
            <label class="text-research">Opss...</label>
            <p>
              Pesquisa não encontrada para este id.
            </p>

            <img
              class="logo-indecx-desktop"
              src="../../../assets/logo-indecx.png"
            />
          </div>
          <div v-if="langSelected === 'us'">
            <label class="text-research">Opss...</label>
            <p>
              Survey not found for this id.
            </p>

            <img
              class="logo-indecx-desktop"
              src="../../../assets/logo-indecx.png"
            />
          </div>
          <div v-if="langSelected === 'es'">
            <label class="text-research">Opss...</label>
            <p>
              Encuesta no encontrada para esta identificación.
            </p>

            <img
              class="logo-indecx-desktop"
              src="../../../assets/logo-indecx.png"
            />
          </div>
        </div>
        <div>
          <img
            style="max-width: 100%; heigth: auto"
            src="../../../assets/error-research.png"
          />
        </div>
        <div class="aling-center-indecx">
          <img
            style="max-width: 100%; heigth: 70px; width: 132px"
            src="../../../assets/logo-indecx.png"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import img from '../../../assets/error-research.png';
import CountryFlag from 'vue-country-flag';

export default {
  name: 'SearchAlreadyAnswered',
  props: {
    lang: {
      type: String,
      required: false,
    },
    situationSearch: {
      type: String
    }
  },

  components: {
    CountryFlag,
  },

  data: () => ({
    img,
    langSelected: 'br',
  }),

  methods: {
    setLangView(locale) {
      this.langSelected = locale;
    },
  },

  mounted() {
    this.langSelected = this.lang;
  },
};
</script>

<style lang="scss" scoped>
.main {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 110px;
  height: 100%;
}

.logo-header {
  max-width: 100%;
  height: 35px;
  width: auto;
}

.logo-indecx-desktop {
  display: none;
}

.content-text {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  margin-top: 108px;
}

.aling-center-indecx {
  justify-content: center;
  display: flex;
}

.align-items {
  display: flex;
  flex-direction: column;
  gap: 64px;
}

.text-research {
  font-size: 26px;
  font-weight: 700;
  line-height: 30px;
  color: #527bf2;
}

#desktop .btn {
  display: none;
}

.container-padding {
  padding: 24px;
}

@media (min-width: 768px) {
  .main {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
  }

  .align-items {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: flex-start;
    flex-direction: row;
  }

  .content-text {
    display: flex;
    width: 350px;
  }

  .aling-center-indecx {
    display: none;
  }

  .logo-header {
    display: none;
  }

  #mobile .btn {
    display: none;
  }

  .logo-indecx-desktop {
    display: block;
    height: 46px;
    width: auto;
  }

  #desktop .btn {
    display: block;
  }

  #desktop {
    justify-content: right;
    display: flex;
    align-items: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/final-pages/search-not-found.vue